import * as Constants from './constants';

export default function render() {
  // eslint-disable-next-line no-invalid-this
  const store = this;
  const mapExists = store.ctx.map && store.ctx.map.getSource(Constants.sources.HOT) !== undefined;
  if (!mapExists) return cleanup();

  const mode = store.ctx.events.currentModeName();

  store.ctx.ui.queueMapClasses({ mode });

  let newHotIds = [];
  let newColdIds = [];

  if (store.isDirty) {
    newColdIds = store.getAllIds();
  } else {
    newHotIds = store.getChangedIds().filter(id => store.get(id) !== undefined);
    newColdIds = store.sources.hot.filter(geojson => geojson.properties.id && newHotIds.indexOf(geojson.properties.id) === -1 && store.get(geojson.properties.id) !== undefined).map(geojson => geojson.properties.id);
  }

  store.sources.hot = [];
  const lastColdCount = store.sources.cold.length;
  store.sources.cold = store.isDirty ? [] : store.sources.cold.filter((geojson) => {
    const id = geojson.properties.id || geojson.properties.parent;
    return newHotIds.indexOf(id) === -1;
  });

  const coldChanged = lastColdCount !== store.sources.cold.length || newColdIds.length > 0;
  newHotIds.forEach(id => renderFeature(id, 'hot'));
  newColdIds.forEach(id => renderFeature(id, 'cold'));

  function renderFeature(id, source) {
    const feature = store.get(id);
    const featureInternal = feature.internal(mode);
    store.ctx.events.currentModeRender(featureInternal, (geojson) => {
      store.sources[source].push(geojson);
    });
  }

  if (coldChanged) {
    store.ctx.map.getSource(Constants.sources.COLD).setData({
      type: Constants.geojsonTypes.FEATURE_COLLECTION,
      features: store.sources.cold
    });
    for (let i = 0; i < store.sources.cold.length; i++) {
      if(store.sources.cold[i].geometry.type===Constants.geojsonTypes.POLYGON||store.sources.cold[i].geometry.type===Constants.geojsonTypes.MULTI_POLYGON){
        store.ctx.map.fire(Constants.events.UPDATE_POLYGON,{feature:store.sources.cold[i],other:"cold"});
        break;
      }
      if(store.sources.cold[i].geometry.type===Constants.geojsonTypes.LINE_STRING||store.sources.cold[i].geometry.type===Constants.geojsonTypes.MULTI_LINE_STRING){
        store.ctx.map.fire(Constants.events.UPDATE_LINE,{feature:store.sources.cold[i],other:"cold"});
        break;
      }
    }
  }

  store.ctx.map.getSource(Constants.sources.HOT).setData({
    type: Constants.geojsonTypes.FEATURE_COLLECTION,
    features: store.sources.hot
  });
  for (let i = 0; i < store.sources.hot.length; i++) {
    if(store.sources.hot[i].geometry.type===Constants.geojsonTypes.POLYGON||store.sources.hot[i].geometry.type===Constants.geojsonTypes.MULTI_POLYGON){
      store.ctx.map.fire(Constants.events.UPDATE_POLYGON,{feature:store.sources.hot[i],other:"hot"});
      break;
    }
    if(store.sources.hot[i].geometry.type===Constants.geojsonTypes.LINE_STRING||store.sources.hot[i].geometry.type===Constants.geojsonTypes.MULTI_LINE_STRING){
      store.ctx.map.fire(Constants.events.UPDATE_LINE,{feature:store.sources.hot[i],other:"hot"});
      break;
    }
  }

  if (store._emitSelectionChange) {
    store.ctx.map.fire(Constants.events.SELECTION_CHANGE, {
      features: store.getSelected().map(feature => feature.toGeoJSON()),
      points: store.getSelectedCoordinates().map(coordinate => ({
        type: Constants.geojsonTypes.FEATURE,
        properties: {},
        geometry: {
          type: Constants.geojsonTypes.POINT,
          coordinates: coordinate.coordinates
        }
      }))
    });
    store._emitSelectionChange = false;
  }

  if (store._deletedFeaturesToEmit.length) {
    const geojsonToEmit = store._deletedFeaturesToEmit.map(feature => feature.toGeoJSON());

    store._deletedFeaturesToEmit = [];

    store.ctx.map.fire(Constants.events.DELETE, {
      features: geojsonToEmit
    });
  }

  cleanup();
  store.ctx.map.fire(Constants.events.RENDER, {});

  function cleanup() {
    store.isDirty = false;
    store.clearChangedIds();
  }
}
